import { useCallback, useEffect, useState } from "react";
import { fetchFounderProductQualityDashboard, FounderProductQualityDashboard } from "../services/founderProductQualityService";

type FounderProductQualityState = {
  data: FounderProductQualityDashboard | null;
  error: string | null;
  isLoading: boolean;
  lastUpdated: Date | null;
  refresh: () => Promise<void>;
};

export function useFounderProductQuality(): FounderProductQualityState {
  const [data, setData] = useState<FounderProductQualityDashboard | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await fetchFounderProductQualityDashboard();
      setData(result);
      setError(result.error);
      setLastUpdated(result.lastUpdated);
    } catch {
      setData(null);
      setError("Unable to load Founder Product Quality.");
      setLastUpdated(new Date());
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    error,
    isLoading,
    lastUpdated,
    refresh
  };
}
